import PropTypes from 'prop-types';

import billingIcon from 'assets/billing.svg';
import userIcon from 'assets/user_icon.svg';

import { SECTIONS } from 'utlis/constants';

import styles from './styles.module.scss';

const SettingsSidebar = ({ activeSection, onSectionChange }) => (
  <div className={styles['settings-sidebar']}>
    <div className={styles.section}>
      <h3 className={styles.heading}>
        <span className={styles.text}>
          Account
        </span>
      </h3>
      <div className={styles.options}>
        <button
          className={`${styles['nav-link']} ${activeSection === SECTIONS.PROFILE ? styles.active : ''}`}
          onClick={() => onSectionChange(SECTIONS.PROFILE)}
        >
          <div className={styles['nav-icon']}>
            <img src={userIcon} alt="Profile" />
          </div>
          <span className={styles['nav-text']}>
            Profile
          </span>
        </button>
      </div>
    </div>

    <div className={styles.section}>
      <h3 className={styles.heading}>
        <span className={styles.text}>
          Workspace
        </span>
      </h3>
      <div className={styles.options}>
        <button
          className={`${styles['nav-link']} ${activeSection === SECTIONS.BILLING ? styles.active : ''}`}
          onClick={() => onSectionChange(SECTIONS.BILLING)}
        >
          <div className={styles['nav-icon']}>
            <img src={billingIcon} alt="Workspace & Billing" />
          </div>
          <span className={styles['nav-text']}>
            Team & Billing
          </span>
        </button>
      </div>
    </div>
  </div>
);

SettingsSidebar.propTypes = {
  activeSection: PropTypes.string.isRequired,
  onSectionChange: PropTypes.func.isRequired,
};

export default SettingsSidebar;
